import {
  NavLink as RouterNavLink,
  NavLinkProps as RouterNavLinkProps,
} from 'react-router-dom';

export type TNavLinkProps = RouterNavLinkProps & {
  disabled?: boolean;
};

export const NavLink = ({ children, ...otherProps }: TNavLinkProps) => {
  return <RouterNavLink {...otherProps}>{children}</RouterNavLink>;
};
